// extracted by mini-css-extract-plugin
module.exports = {"postedBy":"e_Xj","postedByDate":"e_Yj","container":"e_Zj","description":"e__j","title":"e_0j"};